import { useEffect, useState } from "react";

export default function useWindowSize() {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    useEffect(() => {
        const onResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            })
        }

        window.addEventListener("resize", onResize)

        return () => window.removeEventListener("resize", onResize)
    }, [])

    return size
}